import initializeApp, { Params } from 'Jsx/Shared/LayoutV2/initializeLightApp';

import localeEs from 'Jsx/CheckoutV4/i18n/localeEs';
import localePt from 'Jsx/CheckoutV4/i18n/localePt';

import thirdPartyLoader from 'Utils/thirdPartyLoader/thirdPartyLoader';
import gtagProvider from 'Utils/thirdPartyLoader/gtagProvider';
import gtmProvider from 'Utils/thirdPartyLoader/gtmProvider';
import facebookPixelProvider from 'Utils/thirdPartyLoader/facebookPixelProvider';

import App, { AppProps } from './App';

import getInitialState from './getInitialState';

import { RawPageData } from './types';

import { CHECKOUT_PAGE_KEY, initialStatePageKey } from './constants';

function loadThirdParty() {
  thirdPartyLoader({
    providers: [gtagProvider(), gtmProvider(), facebookPixelProvider()],
  });
}

const appConfig: Params<AppProps, RawPageData> = {
  App,
  getInitialState,
  initialStatePageKey,
  i18nConfig: {
    pageKey: CHECKOUT_PAGE_KEY,
    defaults: {
      es: localeEs.es,
      pt: localePt.pt,
    },
    // Localized campaign key
    fallbackNS: ['checkout-campaign'],
  },
  layoutProps: {
    // Handled manually
    pageKey: 'checkout',
    userActivityPageView: null,
    enableWebPerformanceTracking: true,
  },
  extraState: {},
  enableBrowserRUM: true,
  onReactDOMRender: loadThirdParty,
};

initializeApp(appConfig);
